import { render } from "./TicketsGame.vue?vue&type=template&id=17888028&ts=true&lang=pug"
import script from "./TicketsGame.vue?vue&type=script&lang=ts&setup=true"
export * from "./TicketsGame.vue?vue&type=script&lang=ts&setup=true"

import "./TicketsGame.vue?vue&type=style&index=0&id=17888028&lang=scss"

import exportComponent from "/home/runner/work/affolterNET.Tickets/affolterNET.Tickets/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__